var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address-header"},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.clientInfo.name))])]),_vm._v(" "),_c('div',[_vm._v("("+_vm._s(_vm.clientInfo.retailerId)+")")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.clientInfo.address))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.clientInfo.zip)+" "+_vm._s(_vm.clientInfo.city))])])
}
var staticRenderFns = []

export { render, staticRenderFns }